// extracted by mini-css-extract-plugin
export var cardIcon = "_4r-4";
export var checkboxCard = "_4r-0";
export var checkboxCardSelected = "_4r-3";
export var disabled = "_4r-1";
export var outerBorder = "_4r-2";
export var spacerMedium = "_4r-7";
export var spacerSmall = "_4r-6";
export var spacerXsmall = "_4r-5";